
import Component, { ComponentMethods } from "@/module/component/component"
import Request from "@/module/request/request"
import Utils from "@/module/utils/utils"
import Message from "@/module/interactive/message"

import elemIcon from "@/components/elem-icon.vue"
import ElemForm from "@/components/elem-form.vue"

class FormView extends ComponentMethods implements ComponentEntity {
    private value: obj = null

    private type: "create" | "edit" | "config" = "create"

    public components = {
        elemIcon,
        ElemForm,
    }

    data() {
        return {
            id: Utils.getStringId(12),
        }
    }

    props = {
        // 表单结构
        structure: Array,
        // 提交数据接口
        submitApi: String,
        // 修改数据接口
        editApi: {
            type: String,
            required: false,
        },
        // 详情接口
        detailApi: {
            type: String,
            required: false,
        },
        // 提交表单的前置事件
        submitBefore: {
            type: Function,
            required: false,
        },
        // 数据 UUID
        uuid: {
            type: String,
            required: false,
        },
    }

    watch = {
        uuid(value: string) {
            if (value && this.detailApi) {
                // 修改为编辑模式
                this.type = "edit"
                // 获取详情
                this.getDetail(value)
            } else {
                // 修改为新建模式
                this.type = "create"
                // 清空数据
                this.value = {}
            }
        },
    }

    activated() {
        if (this.uuid) {
            // 修改为编辑模式
            this.type = "edit"
            // 获取详情
            this.getDetail(this.uuid)
        } else {
            // 修改为新建模式
            this.type = "create"
        }
    }

    deactivated() {
        // 清空数据
        this.value = {}
        // 刷新
        this.$forceUpdate()
    }

    async onLoad(): Promise<void> {
        // this.formConfig = {}
        // this.value = null
        // const name = (this.entity_name = param.name)
        // const type = (this.type = param.type)
        // const config = (this.pageConfig = await Href.getPage(name))
        // if (config.type === "config") {
        //     this.configName = name
        //     Request.get<obj>(`ADMIN://Setting/Config/GetCreateData`, { name: name }).then(async res => {
        //         // 设置标题
        //         this.setTitle(config.title, "config")
        //         this.value = await Request.get<obj>(`ADMIN://Setting/Config/GetData`, { name: name })
        //         this.formConfig = res
        //     })
        // } else {
        //     Request.get<obj>(`ADMIN://${name}/GetCreateData`).then(async res => {
        //         // 设置标题
        //         this.setTitle(config.title)
        //         // 是否为编辑模式
        //         if (type === "edit") {
        //             // 获取实体
        //             this.value = await Request.get<obj>(`ADMIN://${name}/FindEntity`, { uuid: param.i })
        //         }
        //         this.formConfig = res
        //     })
        // }
    }

    setFormData(obj: obj) {
        Object.keys(obj).forEach(key => {
            this.value[key] = obj[key]
        })
    }

    /**
     * 获取详情
     */
    getDetail(uuid: string) {
        Request.get<obj>(this.detailApi, { uuid }).then(res => {
            this.value = res
            // 更新
            this.$forceUpdate()
        })
    }

    onChangeValue(evt: ElemEvent<obj>) {
        this.value = Utils.copy(evt.value)
    }

    /** 监听滚动到指定模块 */
    onScrollToStepBox(id: string): void {
        Utils.getElements<HTMLDivElement>([`#${this.id}-step`, "#" + id], (b, i) => {
            b.scrollTo({
                top: i.offsetTop - 80,
                left: 0,
                behavior: "smooth",
            })
        })
    }

    /**
     * 获取序号
     */
    getStepNumber(idx: number) {
        const es = Utils.getElementAll(".step-base")

        for (let i = 0, leng = es.length; i < leng; i++) {
            if (es[i].classList.contains(".step-item-" + idx)) {
                return i + 1
            }
        }

        return idx + 1
    }

    async submit() {
        const data = await this.getFormData()

        if (!this.submitApi) {
            return this.$emit("on-submit", {
                tag: "comp-form",
                value: data,
            })
        }

        Request.post((this.type === "edit" ? this.editApi : null) || this.submitApi, data, {
            json: true,
        }).then(() => {
            Message.success(this.getTypeName(), true)
                .onTimeout(() => {
                    this.$emit("on-submit", {
                        tag: "comp-form",
                        value: data,
                    })
                })
                .build()
        })
    }

    getTypeName() {
        switch (this.type) {
            case "create":
                return "添加成功"
            case "edit":
                return "修改成功"
            case "config":
                return "配置成功"
        }
    }

    public onChangeList(type: "append" | "clear", name: string, idx?: number) {
        const step: obj[] = this.step_map[name]

        if (type === "append") {
            step.push({
                key_id: Utils.getUuid(),
            })
        } else {
            step.splice(idx, 1)
        }
    }

    clear() {
        this.value = {}
        // 刷新
        this.$forceUpdate()
    }

    getConditionValue(where: string) {
        if (!where) return true
        return new Function(`return ${where.replace(/&{(\w*)}/g, "this.$1")}`).call(this.value)
    }

    async getFormData() {
        const status = await Utils.getFormData(`#${this.id}-form`)

        if (status.isBlank()) {
            Message.error(status.getMessage())
            throw new Error(status.getMessage())
        }

        var data = {
            ...this.getParams(),
            ...status.getData(),
        }

        if (this.type === "edit") {
            data.uuid = this.value?.uuid
        }

        // 判断并触发父组件提交数据的前置事件
        if (this.submitBefore) {
            var cb = this.submitBefore(data, this.type)

            if (typeof cb !== "undefined") {
                // 判断是否为异步
                if (cb instanceof Promise) {
                    cb = await cb
                }

                if (cb === false) return

                // 使用前置事件返回的数据
                data = cb
            }
        }

        return data
    }
}

export default Component.build(new FormView())
